import { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Typography } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelScanningService from "./LabelScanningService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import DefaultCheckBoxSelect from "../../componentes/checkbox-select/DefaultCheckboxSelect";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultButton from "../../componentes/button/DefaultButton";
import ProductUfi from '../Product/ProductUfi';
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { PrinterClientAutocomplete } from "../../componentes/autocomplete/PrinterClientAutocomplete";
import { DialogConformationGeneric } from "../../componentes/dialog/DialogConfirmationGeneric";

export default function LabelScanningUfi() {

    const { t } = useTranslation();
    const { control } = useForm();
    const [alert, setAlert] = useState(false)

    const userId = sessionStorage.getItem("userId");
    const initialState = {
        userId: userId ? Number(userId) : 0,
        idProductUfi: 0,
        idClient: 2,
        status: 1,
        productName: "",
        checkbox1: false,
        checkbox2: false,
        idLayoutEtiqueta: 0,
        batch: "",
        label: "",
        jdeCode: "",
        nfe: "",
        ufiCode: "",
        receiveDate: null,
        labelQuantity: 0,
        idPrinter: 0
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return { ...initialState }
            case "clearProduct":
                return { ...state, idProductUfi: 0 }
            case 'success':
                return { ...state }
            case 'error':
                return { ...state }
            case 'close_alert':
                return { ...state }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleCheckboxChange = (event) => {
        const { name, checked, type } = event.target;

        if (type === "checkbox") {
            if (checked) {
                if (name === "checkbox1") {
                    dispatch({ type: 'update', data: { ...state, checkbox1: true, checkbox2: false } });
                } else if (name === "checkbox2") {
                    dispatch({ type: 'update', data: { ...state, checkbox1: false, checkbox2: true } });
                }
            } else {
                dispatch({ type: 'update', data: { ...state, [name]: false } });
            }
        } else {
            dispatch({ type: 'update', data: { ...state, [name]: event.target.value } });
        }
    };

    const alertCallback = () => {
        setAlert(false);
    }

    const getAdditionalPropertyValue = (item, propertyName) => {
        return item?.aditionalPropertiesList
            ?.find(x => x.name?.toLowerCase() === propertyName.toLowerCase())?.value;
    };

    const handleChange = (event) => {
        const { name, value, valueComplete } = event.target;

        if (name === "idProductUfi" && valueComplete) {
            const labelValue = Number(getAdditionalPropertyValue(valueComplete, "Etiquetar"));

            if (labelValue === 0) {
                setAlert(true);
                return;
            }
        }

        dispatch({ type: 'update', data: { [name]: value } });
    };

    const handleCloseAlertProduct = () => {
        dispatch({ type: 'close_alert' });
        setError(false);
        setSuccess(false);
    };

    const handleClearProduct = () => {
        dispatch({
            type: 'clearProduct'
        });
        setError(false);
        setSuccess(false);
    }

    const handleClearAll = () => {
        dispatch({ type: 'clear' });
        setError(false);
        setSuccess(false);
    };

    const createBatch = (opcao, receiveDate, nfe) => {
        const date = new Date(receiveDate);
        const dia = String(date.getDate()).padStart(2, "0");
        const mes = String(date.getMonth() + 1).padStart(2, "0");
        const ano = String(date.getFullYear()).slice(2);
        const dataFormatada = `${dia}${mes}${ano}`;
        return `${opcao}${dataFormatada}-${nfe}`;
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("sv-SE");
    };

    const canPrintProduct = () => {

        if (state.idClient === 0 || state.receiveDate === null || state.nfe === "" || state.idProductUfi === 0 || state.labelQuantity <= 0 || state.idPrinter === 0 || (state.checkbox1 === false && state.checkbox2 === false)) {
            setMessage(t("fillRequiredFields"));
            setError(true);
            return false;
        }
        setError(false);
        return true;
    };


    const handlePrintUfiLabel = () => {
        if (!canPrintProduct()) {
            return;
        }

        callUpdateUfiLabelData()
            .then((labelDataAtualizado) => {

                const request = {
                    ...state,
                    ...labelDataAtualizado
                };


                request.receiveDate = state.receiveDate ? formatDate(state.receiveDate) : '';
                LabelScanningService
                    .insertLabelUfi(request)
                    .then((response) => {
                        setMessage(t("printSuccess"));
                        dispatch({ type: 'success' });
                        setSuccess(true);
                        dispatch({ type: 'clearProduct' });
                    })
                    .catch((e) => {
                        console.log(e);
                        setMessage(t("printError"));
                        dispatch({ type: 'error' });
                        setSuccess(false);
                    });
            }
            );

    }

    const callUpdateUfiLabelData = () => {
        const request = {
            ...state
        };

        return LabelScanningService
            .getLabelUfiData(request)
            .then((response) => {
                const updated = updateUfiLabelData(response.data);
                return updated;
            });
    };


    const updateUfiLabelData = (labelUfiData) => {
        const batch = createBatch(state.checkbox1 ? "N" : "I", state.receiveDate, state.nfe);
        const zpl = replaceZplVariables(labelUfiData, batch);

        const updated = {
            productName: !labelUfiData.productName.trim() ? "-" : labelUfiData.productName,
            nationalImported: state.checkbox1 ? "N" : "I",
            idLayoutEtiqueta: labelUfiData.idLayoutEtiqueta,
            idPrinter: state.idPrinter,
            batch: batch,
            label: zpl
        };

        dispatch({ type: 'update', data: updated });

        return updated; // necessário
    };


    const replaceZplVariables = (labelUfiData, batch) => {

        const qrCodeContent = `${labelUfiData.ufiCode};${labelUfiData.jdeCode};${batch}`;
        console.log(labelUfiData);
        const zpl = labelUfiData.zplTemplate
            .replace(/#UFICODE#/g, labelUfiData.ufiCode)
            .replace(/#JDECODE#/g, labelUfiData.jdeCode)
            .replace(/#NomeProduto#/g, labelUfiData.productName)
            .replace(/#Lote#/g, batch)
            .replace(/#QrCodeContent#/g, qrCodeContent)
            .replace(/#InfMann#/g, labelUfiData.mann ?? "")
            .replace(/#InfHengst#/g, labelUfiData.hengst ?? "")
            .replace(/#InfMahle#/g, labelUfiData.mahle ?? "")
            .replace(/#InfTecfil#/g, labelUfiData.tecfil ?? "")
            .replace(/#InfVox#/g, labelUfiData.vox ?? "")
            .replace(/#InfFram#/g, labelUfiData.fram ?? "")
            .replace(/#InfWega#/g, labelUfiData.wega ?? "")
            .replace(/#InfFleetguard#/g, labelUfiData.fleetguard ?? "")
            .replace(/#InfParker#/g, labelUfiData.parker ?? "")
            .replace(/#InfDonaldson#/g, labelUfiData.donaldson ?? "")
            .replace(/#InfSofima#/g, labelUfiData.sofima ?? "")
            .replace(/#InfHydac#/g, labelUfiData.hydac ?? "")
            .replace(/#InfOutros#/g, labelUfiData.outros ?? "")
        return zpl;
    }

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="labelScanning"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                warning={state.warningProduct}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={2}>
                                    <div style={{
                                        pointerEvents: "none",
                                        opacity: 0.8
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name="unLock"
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            disabled={true}
                                            value={state.idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={state.error && state.idClient === 0}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={4}>
                                    <Typography >
                                        {t("selectOptions")}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="checkbox1"
                                                checked={state.checkbox1}
                                                onChange={handleCheckboxChange}
                                            />
                                        }
                                        label={t("national")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="checkbox2"
                                                checked={state.checkbox2}
                                                onChange={handleCheckboxChange}
                                            />
                                        }
                                        label={t("imported")}
                                    />
                                </Grid>

                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <CustomDatePicker
                                        id="receiveDate"
                                        name="receiveDate"
                                        selectedDate={state.receiveDate}
                                        handleChange={handleChange}
                                        error={error && state.receiveDate === null}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        label={t("nfNumber")}
                                        name="nfe"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={state.nfe}
                                        length={30}
                                        error={error && state.nfe === ""}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <PrinterClientAutocomplete
                                        name="idPrinter"
                                        onChange={handleChange}
                                        value={state.idPrinter}
                                        label={t("printer")}
                                        defaultSize
                                        useApi
                                        endPointData={{ idClient: state.idClient }}
                                        endpoint='GetPrinterClient'
                                        error={error && state.idPrinter === 0}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="labelQuantity"
                                        control={control}
                                        type="number"
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={state.labelQuantity}
                                        length={30}
                                        error={error && Number(state.labelQuantity) <= 0}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="idProductUfi" labelName="productUfi" />
                                        }
                                        onChange={handleChange}
                                        name="idProductUfi"
                                        value={state.idProductUfi}
                                        defaultSize
                                        useApi
                                        endpoint='GetProductUfi'
                                        error={error && state.idProductUfi === 0}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={state.status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                    />
                                </Grid>

                            </GridInputRow>

                            {alert && (
                                <DialogConformationGeneric
                                    open={alert}
                                    message="productCannotBeLabeled"
                                    handleClose={alertCallback}
                                    hideCancel={true}
                                    maxWidth={'xs'}
                                />
                            )}

                            <Grid item xs={4} sm={3} md={2}>
                                <DefaultButton print className="primaryButton" onClick={handlePrintUfiLabel} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2}>
                                <DefaultButton clear className="secondaryButton" onClick={handleClearAll} />
                            </Grid>
                            {/* <Grid item xs={4} sm={3} md={2}>
                                <DefaultButton labelName={t("clearProduct")} className="secondaryButton" onClick={handleClearProduct} />
                            </Grid> */}
                        </GridItemContainer>
                    </>
                }
            />
        </>
    );
};
